export const NotificationsTypes = {
  friendRequest: 'friend_request',
  friendRequestConfirm: 'friend_request_confirm',
  comment: 'comment',
  message: 'message',
  cloudFolder: 'cloud_folder',
};
